import React, { useState, useEffect } from 'react';
import { Alert, Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ResponsiveAlert = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 800);
  const [open, setOpen] = useState(window.innerWidth < 800);

  useEffect(() => {
    const handleResize = () => {
      const small = window.innerWidth < 800;
      setIsSmallScreen(small);
      if (!small) setOpen(false); // hide if resized larger
      else setOpen(true);        // show if resized smaller
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  if (!isSmallScreen) return null;

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ top: '16px', width: 'auto', padding: '0 16px', zIndex: 1300 }}
    >
      <Alert
        severity="info"
        onClose={handleClose}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ width: '100%', border: "1px solid",
    borderColor: "info.main", // uses MUI's info color
    p: 2,}}
      >
        This demonstration version is designed to be viewed on browsers 800px and wider. Thanks.
      </Alert>
    </Snackbar>
  );
};

export default ResponsiveAlert;
